const authenticityToken = () => {
  const meta = document.querySelector(`meta[name="csrf-token"]`);
  if (meta) return meta.content;
  return null;
};

export default authenticityToken;
